module.exports = __webpack_public_path__ + "img/riskBlue.e420456c.png";